import { useState } from "react";

export const useForm = (initialState = {}) => {
  const [values, setValues] = useState(initialState);

  const reset = () => {
    setValues(initialState);
  };

  const setForm = (form) => {
    setValues(form);
  };

  const handleInputChange = ({ target }) => {
    setValues({
      ...values,
      [target.name]: target.value,
    });
  };

  const handleManyChange = (fields) => {
    setValues({
      ...values,
      ...fields,
    });
  }

  return [values, handleInputChange, reset, setForm, handleManyChange];
};
